import { AppBar, Box, Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { ReactNode } from 'react'
import { useAuthenticatedUser, useIsSupplier } from '@omnea-app/fe-auth/UserSessionProvider'
import { useIsMobileWidth } from '@omnea-app/fe-browser-utils/useDetectDevice'
import { MobileMenu } from './MobileMenu'
import { UserDetails } from './UserDetails'

interface Props {
  title?: string | ReactNode
  children?: ReactNode
  showLogo?: boolean
}

export const Header = ({ title, children, showLogo = false }: Props) => {
  const userData = useAuthenticatedUser()
  const isSupplier = useIsSupplier()
  const isMobileWidth = useIsMobileWidth()

  if (!userData.isFullyAuthenticated) {
    return null
  }

  return (
    <AppBar
      position="static"
      sx={{
        backgroundImage: userData.org.isQaOrg ? "url('/app/assets/qa-pattern.svg')" : undefined,
      }}
    >
      <Stack alignItems="center" justifyContent="space-between">
        <Stack direction="row" sx={{ width: '100%' }} alignItems="center" spacing={{ xs: 2, md: 6 }}>
          {isMobileWidth && !isSupplier ? <MobileMenu /> : null}
          {showLogo && (
            <Box alignContent="center">
              <Image src="/logo-light.png" alt="Omnea logo" height={20} width={110} />
            </Box>
          )}
          <Box overflow="hidden">
            <Typography variant="upsized-bold" color="inherit">
              {title}
            </Typography>
          </Box>
          <Spacer />
          <UserDetails view={isMobileWidth ? 'minimal' : 'full'} />
        </Stack>
        {children}
      </Stack>
    </AppBar>
  )
}

const Spacer = () => <Box flexGrow={1} />
